import { useEffect } from 'react';

export default function MatchPanelHeights() {
  useEffect(() => {
    const layout = document.querySelector<HTMLElement>('.editor-layout');
    if (!layout) return;

    // Palett (vänster) och grid (mitten)
    const side =
      layout.querySelector<HTMLElement>('.editor-sidebar, .palette-panel, .panel:first-child');
    const mid =
      layout.querySelector<HTMLElement>('.editor-main, .editor-canvas, .canvas-panel, .grid-panel') ||
      (layout.children[1] as HTMLElement | undefined);

    if (!side || !mid) return;

    const mq = window.matchMedia('(min-width: 768px)');
    let rafId = 0;
    let lastSet = -1;

    const applyNow = () => {
      if (!mq.matches) { // lämna desktop/tablet-läge
        if (lastSet !== -1) {
          mid.style.height = '';
          lastSet = -1;
        }
        return;
      }
      const target = Math.round(side.getBoundingClientRect().height);
      if (target > 0 && target !== lastSet) {
        lastSet = target;
        mid.style.height = `${target}px`;
        mid.style.alignSelf = 'flex-start';
        mid.style.boxSizing = 'border-box';
      }
    };

    const schedule = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(applyNow);
    };

    // Observera bara sidopanelen för att undvika loop när vi skriver på mid
    const roSide = new ResizeObserver(() => schedule());
    roSide.observe(side);

    // Reagera på storleksändring/viewport
    const onResize = () => schedule();
    window.addEventListener('resize', onResize);

    const vv = (window as any).visualViewport as VisualViewport | undefined;
    const onVV = () => schedule();
    vv?.addEventListener('resize', onVV);

    // Brytpunktsskifte
    const onMQ = () => schedule();
    if (mq.addEventListener) mq.addEventListener('change', onMQ);
    else mq.addListener(onMQ);

    // Initialt
    schedule();

    return () => {
      cancelAnimationFrame(rafId);
      roSide.disconnect();
      window.removeEventListener('resize', onResize);
      vv?.removeEventListener('resize', onVV);
      if (mq.removeEventListener) mq.removeEventListener('change', onMQ);
      else mq.removeListener(onMQ);
      // städa inline-style om vi lämnar sidan
      if (mid) mid.style.height = '';
    };
  }, []);

  return null;
}